export default {
      id: "in_zone-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "img/icons.svg#in_zone",
      toString: function () {
        return this.url;
      }
    }